import React from "react";
import { motion } from "framer-motion";
import {
  FaBriefcase,
  FaCalendar,
  FaTasks,
  FaAndroid,
  FaPaintBrush,
  FaCode,
} from "react-icons/fa";

const experienceData = [
  {
    position: "Intern Software Engineer",
    company: "RedDot Digital Limited",
    period: "Jan. 2023 - May 2023",
    responsibilities: [
      "Contributed to the development and maintenance of Android applications across multiple stages of the app lifecycle, emphasizing core concepts, API integration, and performance optimization.",
      "Collaborated in UI design and testing efforts, ensuring the creation of user-friendly interfaces while adhering to best practices in clean code and scalable architecture.",
    ],
    icons: [FaAndroid, FaPaintBrush, FaCode],
  },
];

const Experience: React.FC = () => {
  return (
    <section id="experience" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl font-bold mb-12 text-center text-teal-400"
        >
          Work Experience
        </motion.h2>
        <div className="max-w-3xl mx-auto">
          {experienceData.map((job, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="mb-8 bg-gray-800 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                <FaBriefcase className="text-teal-400 mr-2" size={24} />
                <h3 className="text-xl font-semibold text-teal-400">
                  {job.position}
                </h3>
              </div>
              <div className="flex items-center mb-4 text-gray-300">
                <FaCalendar className="text-teal-500 mr-2" size={18} />
                <p>
                  {job.company} | {job.period}
                </p>
              </div>
              <ul className="space-y-3">
                {job.responsibilities.map((resp, idx) => (
                  <motion.li
                    key={idx}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{
                      duration: 0.3,
                      delay: index * 0.1 + idx * 0.1,
                    }}
                    className="flex items-start"
                  >
                    <FaTasks
                      className="text-teal-500 mr-2 mt-1 flex-shrink-0"
                      size={16}
                    />
                    <span className="text-gray-300">{resp}</span>
                  </motion.li>
                ))}
              </ul>
              <div className="mt-4 flex justify-end space-x-2">
                {job.icons.map((Icon, idx) => (
                  <motion.div
                    key={idx}
                    whileHover={{ scale: 1.2, rotate: 15 }}
                    whileTap={{ scale: 0.8 }}
                  >
                    <Icon className="text-teal-400" size={24} />
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
